import { ARKON, EXTERNAL_CS } from '@/consts/systems.consts';

export interface PhysicalExaminationData {
  vitalSigns: {
    bloodPressureSystolic: string;
    bloodPressureDiastolic: string;
    heartRate: string;
    respiratoryRate: string;
    temperature: string;
    oxygenSaturation: string;
  };
  headNeck: {
    normal?: boolean;
    cranium: string;
    eyes: string;
    ent: string;
    neck: string;
  };
  thorax: {
    normal?: boolean;
    respiratory: string;
    cardiovascular: string;
  };
  abdomen: {
    normal?: boolean;
    inspection: string;
    auscultation: string;
    palpation: string;
    percussion: string;
  };
  extremities: {
    normal?: boolean;
    inspection: string;
    edema: string;
    skinHair: string;
    pulses: string;
  };
  neurological: {
    normal?: boolean;
    alertnessOrientation: string;
    speech: string;
    cranialNerves: string;
    muscleStrength: string;
    sensation: string;
    gaitBalance: string;
    cerebellarSigns: string;
  };
}

export interface PhysicalExaminationInputProps {
  onChange?: (data: PhysicalExaminationData) => void;
  initialData?: PhysicalExaminationData;
}

// FHIR code mappings for Physical Examination sections
export const PHYSICAL_EXAM_SECTION_CODES: Record<
  string,
  { code: string; display: string }
> = {
  headNeck: {
    code: ARKON.CS.PHYSICAL_EXAMINATION.CODES.HEAD_NECK,
    display: 'Head and Neck Examination',
  },
  thorax: {
    code: ARKON.CS.PHYSICAL_EXAMINATION.CODES.THORAX,
    display: 'Thorax Examination',
  },
  abdomen: {
    code: ARKON.CS.PHYSICAL_EXAMINATION.CODES.ABDOMEN,
    display: 'Abdomen Examination',
  },
  extremities: {
    code: ARKON.CS.PHYSICAL_EXAMINATION.CODES.EXTREMITIES,
    display: 'Extremities Examination',
  },
  neurological: {
    code: ARKON.CS.PHYSICAL_EXAMINATION.CODES.NEUROLOGICAL,
    display: 'Neurological Examination',
  },
};

// LOINC code mappings for vital signs
export const VITAL_SIGNS_CODES: Record<
  string,
  { code: string; display: string; unit: string }
> = {
  heartRate: {
    code: EXTERNAL_CS.LOINC.CODES.HEART_RATE,
    display: 'Heart rate',
    unit: '/min',
  },
  respiratoryRate: {
    code: EXTERNAL_CS.LOINC.CODES.RESPIRATORY_RATE,
    display: 'Respiratory rate',
    unit: '/min',
  },
  temperature: {
    code: EXTERNAL_CS.LOINC.CODES.BODY_TEMPERATURE,
    display: 'Body temperature',
    unit: 'Cel',
  },
  oxygenSaturation: {
    code: EXTERNAL_CS.LOINC.CODES.OXYGEN_SATURATION,
    display: 'Oxygen saturation',
    unit: '%',
  },
};
